var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferSlider2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 20C27.294 20 26 19.856 26 19.632V40H30V19.632C30 19.856 28.706 20 28 20ZM30 4.368V0H26V4.368C24 5.194 22 7.392 22 10C22 13.314 24.686 16 28 16C31.314 16 34 13.314 34 10C34 7.392 32 5.194 30 4.368ZM14 20.368V0H10V20.368C10.628 20.144 11.294 20 12 20C12.706 20 14 20.144 14 20.368ZM18 30C18 32.608 16 34.806 14 35.632V40H10V35.632C8 34.806 6 32.608 6 30C6 26.686 8.686 24 12 24C15.314 24 18 26.686 18 30Z",
    fill: "#F68424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSlider2);
export default __webpack_public_path__ + "static/media/offer-slider-2.e71e2945f2e56f9c3094aef8deda890f.svg";
export { ForwardRef as ReactComponent };